"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BallScrewElement = void 0;
/**
 * Interface for drawable screw component
 */
const two_js_1 = __importDefault(require("two.js"));
const QuatableElement_1 = require("./QuatableElement");
class BallScrewElement extends QuatableElement_1.QuotableElement {
    /**
     * Method to draw component
     */
    draw() {
        return new two_js_1.default.Group();
    }
}
exports.BallScrewElement = BallScrewElement;
